import React, {useEffect,useState} from 'react';
import './GrowthCampaignBanner.css';
export default function GrowthCampaignBanner({user}) {
 const [now,setNow]=useState(Date.now());
 useEffect(()=>{const timer=setInterval(()=>setNow(Date.now()),60000);return()=>clearInterval(timer);},[]);
 const promotion=user?.growthPromotion;
 const expires=Math.min(Date.parse(promotion?.expiresAt),Date.parse('2027-03-31T23:00:00Z'));
 if(!promotion?.active || !Number.isFinite(expires) || expires<=now)return null;
 const days=Math.ceil((expires-now)/86400000);
 return <aside className="wl-growth-banner" aria-label="WAVELINES Growth Campaign">
  <span className="wl-growth-banner-mark" aria-hidden="true">↗</span>
  <div><strong>You're enjoying the WAVELINES Growth Campaign</strong>
   <p>Complimentary Growth access until <b>31 March 2027</b> (WAT). No automatic charge. Your records are retained.</p>
  </div>
  <span className="wl-growth-days">{days} days left</span>
 </aside>;
}
